<div *ngIf="!showAgentProfile">
    <span>Conversational AI </span> > <span class="fw-bold"> Agent Catalog</span>
</div>
<div *ngIf="showAgentProfile">
    Conversational AI > <span (click)="showAgentProfile = false" class="cursor-pointer"> Agent Catalog </span> > <span class="fw-bold"> Agent Profile</span>
</div>
<ng-container>
    <div class="d-flex flex-row justify-content-between align-items-center mt-4">
        <mat-tab-group
            mat-stretch-tabs="false"
            mat-align-tabs="start"
            [(selectedIndex)]="selectedTabIndex"
            (selectedIndexChange)="onTabChange($event)">
            <mat-tab>
                <ng-template mat-tab-label>
                    All Agents ({{ allAgentsCount }})
                </ng-template>
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label>
                    Published Agents ({{ publishedAgentsCount }})
                </ng-template>
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label>
                    Draft Agents ({{ draftAgentsCount }})
                </ng-template>
            </mat-tab>
        </mat-tab-group>
        <div class="d-flex flex-row align-items-center gap-2">
        <button class="audit-trail-btn" (click)="openAuditTrail()" title="Audit Logs">
            <mat-icon>manage_search</mat-icon>
        </button>
        <button mat-raised-button class="create-btn" (click)="createAgent()" [disabled]="isCreatingAgent">
            <mat-icon *ngIf="!isCreatingAgent" class="create-icon">add</mat-icon>
            <div *ngIf="isCreatingAgent" class="spinner-border spinner-border-sm me-2" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
            {{ isCreatingAgent ? 'Creating...' : 'Create Agent' }}
        </button>
        </div>
    </div>

    <!-- Loading State -->
    <div class="loading-container text-center py-5" *ngIf="isLoading">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
        <p class="mt-3 text-muted">Loading agents...</p>
    </div>

    <!-- Empty State -->
    <div class="empty-state text-center py-5" *ngIf="!isLoading && filteredAgents.length === 0">
        <p class="text-muted">No agents found in this category.</p>
    </div>

    <!-- Agent List -->
    <div class="d-flex flex-row mt-4 agent-card" *ngFor="let agent of filteredAgents"
        (click)="getAgentProfile()" (keydown)="(null)">
        <div class="d-flex flex-column w-5">
            <img [src]="agentImageMap[agent.Id]" alt="avatar" class="rounded-circle" width="60" height="60" />
        </div>
        <div class="d-flex flex-column w-40 justify-content-center">
            <div class="fs-5 fw-bold mb-2">{{ agent.Name }}</div>
            <div class="text-muted mb-2">{{ agent.Description || 'N/A' }}</div>
            <div class="d-flex align-items-center">
                <span class="text-muted me-2">Status:</span>
                <span>{{ agent.Status }}</span>
            </div>
        </div>
        <!--<div class="d-flex flex-column justify-content-center align-items-center w-45">
            <div class="d-flex flex-row">
                <div class="d-flex flex-column align-items-center">
                    <span class="count1 fw-bold">300</span>
                    <span class="fs-5">Lead to booking ratio</span>
                </div>
                <mat-divider vertical="true" class="divider-boder"></mat-divider>
                <div class="d-flex flex-column align-items-center">
                    <span class="count2 fw-bold">300</span>
                    <span class="fs-5">Total calls made</span>
                </div>
                <mat-divider vertical="true" class="divider-boder"></mat-divider>
                <div class="d-flex flex-column align-items-center">
                    <span class="count3 fw-bold">300</span>
                    <span  class="fs-5">Hours saved</span>
                </div>
            </div>
        </div> -->
        <div class="d-flex flex-column justify-content-center align-items-end w-10 ms-auto">
            <div class="d-flex flex-row align-items-center gap-3">
                <img *ngIf="!isMassCallingAgent(agent)" class="cursor-pointer" [src]="iconImages['edit_icon']" alt="Edit" title="Edit" (click)="editAgent(agent.Id, $event)"/>
                <div *ngIf="!isMassCallingAgent(agent)" class="duplicate-button-container">
                    <img *ngIf="!isDuplicating(agent.Id)"
                         class="cursor-pointer"
                         [src]="iconImages['duplicate_icon']"
                         alt="Duplicate"
                         title="Duplicate"
                         (click)="duplicateAgent(agent.Id, $event)"/>
                    <div *ngIf="isDuplicating(agent.Id)" class="duplicate-loading">
                        <div class="spinner-border spinner-border-sm" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
                <div *ngIf="!isMassCallingAgent(agent)" class="delete-button-container">
                    <button *ngIf="isDeletingId !== agent.Id"
                            class="delete-icon-btn"
                            title="Delete"
                            (click)="openDeleteConfirm(agent, $event)">
                        <mat-icon class="delete-icon">delete</mat-icon>
                    </button>
                    <div *ngIf="isDeletingId === agent.Id" class="duplicate-loading">
                        <div class="spinner-border spinner-border-sm delete-spinner" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<!-- Error Modal -->
<div class="error-modal" [class.active]="showErrorModal" (click)="closeErrorModal()">
    <div class="error-modal-panel" (click)="$event.stopPropagation()">
        <div class="error-modal-header">
            <h3 class="error-modal-title">
                <div class="error-icon-circle">
                    <mat-icon class="error-icon-inner">report_problem</mat-icon>
                </div>
                Error
            </h3>
            <button class="error-modal-close" (click)="closeErrorModal()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <p class="error-modal-message">{{ errorModalMessage }}</p>
        <div class="error-modal-footer">
            <button class="error-modal-ok-btn" (click)="closeErrorModal()">
                OK
            </button>
        </div>
    </div>
</div>

<!-- Delete Confirmation Modal -->
<div class="error-modal" [class.active]="showDeleteConfirmModal" (click)="closeDeleteConfirmModal()">
    <div class="error-modal-panel" (click)="$event.stopPropagation()">
        <div class="error-modal-header">
            <h3 class="error-modal-title">
                <div class="confirm-icon-circle">
                    <mat-icon class="error-icon-inner">delete</mat-icon>
                </div>
                Delete Agent
            </h3>
            <button class="error-modal-close" (click)="closeDeleteConfirmModal()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <p class="error-modal-message">
            Are you sure you want to delete <strong>{{ agentToDelete?.name }}</strong>? This action cannot be undone.
        </p>
        <div class="error-modal-footer confirm-footer">
            <button class="error-modal-ok-btn cancel-btn" (click)="closeDeleteConfirmModal()">
                Cancel
            </button>
            <button class="error-modal-ok-btn delete-confirm-btn" (click)="confirmDelete()">
                Delete
            </button>
        </div>
    </div>
</div>

<!-- Success Modal -->
<div class="error-modal" [class.active]="showSuccessModal" (click)="closeSuccessModal()">
    <div class="error-modal-panel" (click)="$event.stopPropagation()">
        <div class="error-modal-header">
            <h3 class="error-modal-title">
                <div class="success-icon-circle">
                    <mat-icon class="error-icon-inner">check</mat-icon>
                </div>
                Success
            </h3>
            <button class="error-modal-close" (click)="closeSuccessModal()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <p class="error-modal-message">{{ successModalMessage }}</p>
        <div class="error-modal-footer">
            <button class="error-modal-ok-btn" (click)="closeSuccessModal()">
                OK
            </button>
        </div>
    </div>
</div>

<app-agent-audit-trail
    [isVisible]="showAuditTrail"
    (close)="showAuditTrail = false">
</app-agent-audit-trail>

<!--<ng-template>
    <div class="d-flex flex-row justify-content-between mt-4">
        <div class="d-flex flex-column w-70 mr-20">
            <div class="d-flex flex-row agent-details h-219 p-3 mb-3">
                <div class="w-25">
                    <div class="d-flex flex-row justify-content-between align-items-start">
                        <img [src]="agentImageMap[1]" alt="avatar" class="rounded-circle" width="80" height="80" />
                        <img class="cursor-pointer" [src]="iconImages['cardedit_icon']" alt="Agent Edit"/>
                    </div>
                    <div class="d-flex align-items-center justify-content-between mt-4">
                        <span class="fs-5 fw-medium"> Ava - Fall 2024 </span>
                        <span class="status-tag">IN-ACTIVE</span>
                    </div>
                    <div class="mt-2">
                        ID : 566e909d-e8ca-4335-8107-266e844a4071
                    </div>
                </div>
                <mat-divider vertical="true" class="divider-boder"></mat-divider>
                <div class="d-flex flex-column justify-content-around w-75">
                    <div class="d-flex flex-row justify-content-between w-100">
                        <div class="d-flex flex-column">
                            <span class="a-title">Status</span>
                            <span>
                                <mat-slide-toggle
                                    [(ngModel)]="isToggleOn"
                                    [title]="isToggleOn ? 'Active' : 'In-Active'">
                                    In-Active
                                </mat-slide-toggle>
                            </span>
                        </div>
                        <div class="d-flex flex-column">
                            <span class="a-title">Name</span>
                            <span>Ava - General Prescreen - Fall 2024</span>
                        </div>
                        <div class="d-flex flex-column">
                            <span class="a-title">Phone</span>
                            <span>8005007777</span>
                        </div>
                    </div>
                    <div class="d-flex flex-row justify-content-between w-100">
                        <div class="d-flex flex-column">
                            <span class="a-title">Campaign</span>
                            <span>DM - General Prescreening</span>
                        </div>
                        <div class="d-flex flex-column">
                            <span class="a-title">Language</span>
                            <span>English | USA</span>
                        </div>
                        <div class="d-flex flex-column">
                            <span class="a-title"></span>
                            <span></span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="agent-details h-740 p-3">
                <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
                    <mat-tab label="Work Flow">
                        <div class="agent-detail-section">
                            <div *ngFor="let work of workFlowList">
                                <div class="work-section mt-4 mb-4 mr-10 p-3">
                                    details
                                </div>
                            </div>
                        </div>
                    </mat-tab>
                    <mat-tab label="Studies"></mat-tab>
                    <mat-tab label="Scripts"></mat-tab>
                </mat-tab-group>
            </div>
        </div>
        <div class="agent-details w-30 p-3">
            <span class="analytics">Analytics</span>
            <div class="chart-section mt-3">
                Graph
            </div>
            <div class="chart-section mt-3">
                Graph
            </div>
            <div class="chart-section mt-3">
                Graph
            </div>
        </div>
    </div>
</ng-template> -->
